const state = {
    county: 20
}

const mutations = {
    increment: (state, payload) => {
        state.county = state.county + 1
    },
}

const getters = {
    getCount(state) {
        return state.county;
    }
}

const actions = {
    increment(context) {
        console.log("In increment action");
        context.commit('increment')
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/dummy.js